export default "__VITE_ASSET__wwVJrNt3__"